import React, { useRef } from 'react'
import { useTranslation, Trans } from "react-i18next";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import './AboutText.scss';

gsap.registerPlugin(ScrollTrigger);

const AboutText = () => {
  const {t} = useTranslation();
  const title = useRef(null);
  const subtitle = useRef(null);
  const text = useRef(null);
  const container = useRef(null);

  useGSAP(() => {
    gsap.set(title.current, {x: -1000, opacity: 0})
    gsap.set(subtitle.current, {yPercent: -100, opacity: 0})
    gsap.set(text.current, {x: -1000, opacity: 0})
    gsap.to(title.current, {
      scrollTrigger: title.current,
      opacity: 1, 
      x: 0, 
      duration: 1, 
      ease: "slow",
    });
    gsap.to(text.current, { 
      scrollTrigger: text.current, 
      opacity: 1, 
      x: 0, 
      duration: 1, 
      ease: "slow", 
      delay: 0.8 
    });
    gsap.to(subtitle.current, { 
      scrollTrigger: text.current, 
      opacity: 1, 
      yPercent: 0, 
      duration: 1, 
      ease: "slow", 
      delay: 1.5 
    });
    gsap.fromTo("li", {
      opacity: 0,
      yPercent: -100
    }, {
      scrollTrigger: '.about-text__numbers',
      opacity: 1,
      yPercent: 0,
      duration: 1, 
      ease: "slow", 
      stagger: 0.3,
      delay: 0.5 
    });
  }, { scope: container })

  return (
    <section id="about">
      <div className="container h-full" ref={container}>
          <h2 className="app__title skills__title" ref={title}>
            <Trans i18nKey="about_title">Let me introduce myself</Trans>
          </h2>
              <>
                <p className="about-text__discription" ref={text}>
                  <Trans i18nKey="about_text">I'm a frontend developer in love with the Web, based in Ukraine. I specialize in creating dynamic, user-friendly websites using JS, HTML, CSS, and modern tools. With a keen eye for design and functionality, I build responsive, high-performance websites.</Trans>
                </p>
                <div className="about-text__data">
                <ul className='about-text__numbers'>
                        <li
                          key={`num1`}
                        >
                          <h3>50+</h3>
                          <p>{t('about_numbers.1')}</p>
                        </li>
                        <li
                          key={`num2`}
                        >
                          <h3>4+</h3>
                          <p>{t('about_numbers.2')}</p>
                        </li>
                        <li
                          key={`num3`}
                        >
                          <h3>200+</h3>
                          <p>{t('about_numbers.3')}</p>
                        </li>
                        <li
                          key={`num4`}
                        >
                          <h3>93+</h3>
                          <p>{t('about_numbers.4')}</p>
                        </li>
                    </ul>
                  <div className="about-text__list">
                    <h3
                      className="about-text__title"
                      ref={subtitle}
                    >
                      <Trans i18nKey="about_subtitle">Here’s what I bring to the table:</Trans>
                    </h3>
                    <ul>
                        <li
                          key={`competency1`}
                        >
                          {t('about_list.1')}
                        </li>
                        <li
                          key={`competency2`}
                        >
                          {t('about_list.2')}
                        </li>
                        <li
                          key={`competency3`}
                        >
                          {t('about_list.3')}
                        </li>
                        <li
                          key={`competency4`}
                        >
                          {t('about_list.4')}
                        </li>
                    </ul>
                  </div>
                </div>
            </>
      </div>
    </section>
  );
}

export default AboutText